// Gusto39 Produktseite: Galerie, Mengenwahl, In den Warenkorb, Palette zusammenstellen, Margenrechner, mitlaufende Leiste.
// Ohne JavaScript bleibt alles bedienbar: Formulare gehen normal an /cart/add, die Galerie lässt sich wischen.
// Preise kommen nur aus dem Liquid (snippets/price.liquid); das Skript rechnet nur mit den dort ausgegebenen Cent-Werten.
(() => {
  const root = document.querySelector('[data-product]');
  if (!root) return;
  const sectionId = root.dataset.sectionId;
  const status = (el, text, error = false) => {
    if (!el) return;
    el.textContent = text;
    el.classList.toggle('is-error', error);
  };
  const t = window.Gusto39Product || {};

  // Große Bildansicht: Klick aufs Bild öffnet, Pfeile/Wischen blättern, Esc oder Klick daneben schließt.
  const lightbox = document.querySelector('[data-lightbox]');
  const zooms = [...document.querySelectorAll('[data-zoom]')];
  if (lightbox && zooms.length && typeof lightbox.showModal === 'function') {
    const img = document.createElement('img');
    img.className = 'lightbox__img';
    img.decoding = 'async';
    lightbox.prepend(img);
    const counter = lightbox.querySelector('[data-lightbox-count]');
    const galleryTrack = document.querySelector('[data-gallery-track]');
    let index = 0;
    const show = (i) => {
      index = (i + zooms.length) % zooms.length;
      img.src = zooms[index].dataset.zoomSrc;
      img.alt = zooms[index].dataset.zoomAlt;
      img.classList.toggle('lightbox__img--foto', index > 0);
      if (counter) counter.textContent = `${index + 1} / ${zooms.length}`;
    };
    zooms.forEach((btn, i) => btn.addEventListener('click', () => {
      show(i);
      lightbox.showModal();
      document.documentElement.style.overflow = 'hidden';
    }));
    lightbox.addEventListener('close', () => {
      document.documentElement.style.overflow = '';
      if (galleryTrack) galleryTrack.scrollTo({ left: galleryTrack.clientWidth * index });
    });
    lightbox.querySelectorAll('[data-lightbox-step]').forEach((btn) => btn.addEventListener('click', () => show(index + Number(btn.dataset.lightboxStep))));
    lightbox.querySelector('[data-lightbox-close]').addEventListener('click', () => lightbox.close());
    lightbox.addEventListener('click', (event) => { if (event.target === lightbox || event.target === img) lightbox.close(); });
    lightbox.addEventListener('keydown', (event) => {
      if (zooms.length < 2 || (event.key !== 'ArrowRight' && event.key !== 'ArrowLeft')) return;
      event.preventDefault();
      show(index + (event.key === 'ArrowRight' ? 1 : -1));
    });
    let startX = null;
    lightbox.addEventListener('touchstart', (event) => { startX = event.touches[0].clientX; }, { passive: true });
    lightbox.addEventListener('touchend', (event) => {
      if (startX === null || zooms.length < 2) return;
      const dx = event.changedTouches[0].clientX - startX;
      startX = null;
      if (Math.abs(dx) > 50) show(index + (dx < 0 ? 1 : -1));
    });
  }

  // Galerie: Zähler und Vorschaubilder folgen dem Wischen.
  const track = document.querySelector('[data-gallery-track]');
  if (track) {
    const slides = [...track.children];
    const thumbs = [...document.querySelectorAll('[data-gallery-to]')];
    const count = document.querySelector('[data-gallery-count]');
    let current = 0;
    const update = () => {
      const index = Math.round(track.scrollLeft / track.clientWidth);
      if (index === current) return;
      current = index;
      if (count) count.textContent = `${index + 1} / ${slides.length}`;
      thumbs.forEach((thumb, i) => thumb.setAttribute('aria-current', String(i === index)));
    };
    track.addEventListener('scroll', () => requestAnimationFrame(update), { passive: true });
    thumbs.forEach((thumb) => thumb.addEventListener('click', () => {
      const reduce = matchMedia('(prefers-reduced-motion: reduce)').matches;
      track.scrollTo({ left: track.clientWidth * Number(thumb.dataset.galleryTo), behavior: reduce ? 'auto' : 'smooth' });
    }));
    track.addEventListener('keydown', (event) => {
      if (event.key !== 'ArrowRight' && event.key !== 'ArrowLeft') return;
      event.preventDefault();
      const next = Math.min(slides.length - 1, Math.max(0, current + (event.key === 'ArrowRight' ? 1 : -1)));
      track.scrollTo({ left: track.clientWidth * next });
    });
  }

  // Geldbeträge im Format des Shops (nur für Werte, die price.liquid schon freigegeben hat).
  const calcEl = document.querySelector('[data-calc]');
  const currency = root.dataset.currency || 'EUR';
  const locale = root.dataset.locale || document.documentElement.lang || 'de';
  const money = (cents) => new Intl.NumberFormat(locale, { style: 'currency', currency }).format(cents / 100);

  // Mengenwahl (Kaufbox, mitlaufende Leiste, Produktkarten).
  const form = document.querySelector('[data-product-form]');
  const mainQty = form?.querySelector('[data-qty-input]');
  const mirror = document.querySelector('[data-qty-mirror]');
  const summary = form?.querySelector('[data-qty-summary]');
  const updateSummary = () => {
    if (!form || !summary || !form.dataset.unitCents) return;
    const qty = Math.max(1, parseInt(mainQty.value, 10) || 1);
    const perCarton = Number(form.dataset.perCarton) || 0;
    // Erst die Kartons (das, was oben gezählt wird), die Stückzahl nur als Erklärung dahinter.
    const cartons = document.createElement('b');
    cartons.textContent = qty === 1 ? (t.qtyCartonsOne || '1 Karton') : (t.qtyCartons || '{{ count }} Kartons').replace('{{ count }}', qty);
    const line = [cartons];
    if (perCarton > 0) {
      line.push(` ${(t.qtyPieces || 'à {{ per }} Stück = {{ total }} Stück').replace('{{ per }}', perCarton).replace('{{ total }}', (qty * perCarton).toLocaleString(locale))}`);
    }
    const sum = document.createElement('span');
    sum.className = 'pbox__sum-total';
    sum.textContent = (t.qtySum || 'Summe {{ amount }} netto').replace('{{ amount }}', money(qty * Number(form.dataset.unitCents)));
    const first = document.createElement('span');
    first.append(...line);
    summary.replaceChildren(first, sum);
  };
  const syncQty = (source) => {
    const value = Math.max(1, parseInt(source.value, 10) || 1);
    if (mainQty) mainQty.value = value;
    if (mirror) mirror.value = value;
    updateSummary();
  };
  document.addEventListener('click', (event) => {
    const btn = event.target.closest('[data-qty]');
    if (!btn) return;
    const input = btn.parentElement.querySelector('input');
    input.value = Math.max(1, (parseInt(input.value, 10) || 1) + Number(btn.dataset.qty));
    if (input.max) input.value = Math.min(Number(input.max), Number(input.value));
    if (input === mainQty || input === mirror) syncQty(input);
    else input.dispatchEvent(new Event('input', { bubbles: true }));
  });
  [mainQty, mirror].forEach((input) => input?.addEventListener('input', () => syncQty(input)));
  updateSummary();

  // Nach dem Hinzufügen: Warenkorb-Leiste und Zähler im Kopf neu aus dem Liquid holen.
  const refreshCart = async () => {
    try {
      const html = await (await fetch(`${location.pathname}?section_id=${sectionId}`)).text();
      const doc = new DOMParser().parseFromString(html, 'text/html');
      const fresh = doc.querySelector('[data-cart-status]');
      const old = document.querySelector('[data-cart-status]');
      if (fresh && old) old.replaceWith(fresh);
      const cart = await (await fetch(`${window.Shopify?.routes?.root || '/'}cart.js`)).json();
      const link = document.querySelector('.header__action[href$="/cart"]');
      if (link) {
        let badge = link.querySelector('.header__count');
        if (!badge) {
          badge = Object.assign(document.createElement('span'), { className: 'header__count' });
          badge.setAttribute('aria-hidden', 'true');
          link.append(badge);
        }
        badge.textContent = cart.item_count;
      }
    } catch { /* Leiste bleibt beim alten Stand, Warenkorb stimmt trotzdem */ }
    document.dispatchEvent(new CustomEvent('cart:updated'));
  };

  const addToCart = async (body, isJson) => {
    const res = await fetch(`${window.Shopify?.routes?.root || '/'}cart/add.js`, {
      method: 'POST',
      headers: isJson ? { 'Content-Type': 'application/json', Accept: 'application/json' } : { Accept: 'application/json' },
      body,
    });
    const data = await res.json();
    if (!res.ok) throw new Error(data.description || data.message || '');
    return data;
  };

  if (form) {
    const out = form.querySelector('[data-form-status]');
    const submit = form.querySelector('[type="submit"]');
    form.addEventListener('submit', async (event) => {
      event.preventDefault();
      submit.setAttribute('aria-busy', 'true');
      submit.disabled = true;
      try {
        await addToCart(new FormData(form), false);
        status(out, t.added || 'Im Warenkorb.');
        refreshCart();
      } catch (error) {
        status(out, error.message || t.error || 'Das hat nicht geklappt. Bitte versuchen Sie es noch einmal.', true);
      } finally {
        submit.removeAttribute('aria-busy');
        submit.disabled = false;
      }
    });
    document.querySelector('[data-sticky-add]')?.addEventListener('click', () => form.requestSubmit());
  }

  // Palette: Summe muss genau eine oder mehrere volle Paletten ergeben.
  const pallet = document.querySelector('[data-pallet-form]');
  if (pallet) {
    const cap = Number(pallet.dataset.capacity);
    const inputs = [...pallet.querySelectorAll('[data-flavor]')];
    const sumEl = pallet.querySelector('[data-pallet-sum]');
    const bar = pallet.querySelector('[data-pallet-bar]');
    const rest = pallet.querySelector('[data-pallet-rest]');
    const submit = pallet.querySelector('[data-pallet-submit]');
    const label = pallet.querySelector('[data-pallet-submit-label]');
    const out = pallet.querySelector('[data-form-status]');
    const fmt = (s, map) => s.replace(/\{\{\s*(\w+)\s*\}\}/g, (_, k) => map[k]);
    const countEl = pallet.querySelector('[data-pallet-count]');
    const priceBox = pallet.querySelector('[data-pallet-price]');
    // Nur den Betrag tauschen, damit die Formatierung von .price__amount bleibt.
    const priceEl = priceBox?.querySelector('.price__amount') || priceBox;
    const perEl = pallet.querySelector('[data-pallet-per]');
    const priceText = priceEl?.textContent.trim() || '';
    const perText = perEl?.textContent || '';
    const read = () => inputs.map((i) => Math.max(0, parseInt(i.value, 10) || 0));
    const count = () => Math.min(20, Math.max(1, parseInt(countEl?.value, 10) || 1));
    // Eine Sorte darf nur so weit steigen, wie noch Platz auf der Palette ist.
    const clamp = (input) => {
      if (!input || !inputs.includes(input) || input.type === 'hidden') return;
      const others = inputs.reduce((a, i) => a + (i === input ? 0 : Math.max(0, parseInt(i.value, 10) || 0)), 0);
      const v = Math.max(0, parseInt(input.value, 10) || 0);
      if (v > cap - others) input.value = cap - others;
    };
    const single = inputs.length === 1 && inputs[0].type === 'hidden';
    const update = () => {
      const qtys = read();
      const sum = qtys.reduce((a, b) => a + b, 0);
      const missing = cap - sum;
      const full = missing === 0;
      const n = count();
      inputs.forEach((i, k) => i.classList.toggle('has-value', qtys[k] > 0));
      let txt = fmt(t.palletOf || '{{ sum }} von {{ total }} Kartons', { sum: sum.toLocaleString(locale), total: cap.toLocaleString(locale) });
      if (n > 1) txt += ' · ' + fmt(t.palletTotal || '{{ count }} Paletten, {{ cartons }} Kartons gesamt', { count: n, cartons: (cap * n).toLocaleString(locale) });
      if (single) txt = fmt(t.palletTotal || '{{ count }} Paletten, {{ cartons }} Kartons gesamt', { count: n, cartons: (cap * n).toLocaleString(locale) });
      sumEl.textContent = txt;
      if (priceEl) {
        const value = (Number(priceBox.dataset.cents) * n) / 100;
        priceEl.textContent = priceText.replace(/\d[\d.,\s\u00a0]*\d/, value.toLocaleString(locale, { minimumFractionDigits: 2, maximumFractionDigits: 2 }));
      }
      if (perEl) perEl.textContent = n > 1 ? fmt(t.palletsNet || '{{ count }} Paletten ({{ cartons }} Kartons):', { count: n, cartons: (cap * n).toLocaleString(locale) }) : perText;
      const pct = Math.round((sum / cap) * 100);
      bar.setAttribute('aria-valuenow', pct);
      bar.firstElementChild.style.width = `${pct}%`;
      rest.hidden = full;
      if (!full) rest.innerHTML = fmt(t.palletRest || 'Noch <b>{{ count }} Kartons</b> bis zur vollen Palette', { count: missing.toLocaleString(locale) });
      submit.classList.toggle('btn--primary', full);
      submit.classList.toggle('is-open', !full);
      submit.setAttribute('aria-disabled', String(!full));
      label.textContent = full
        ? (n > 1 ? fmt(t.palletPreorderN || '{{ count }} Paletten vorbestellen', { count: n }) : (t.palletPreorder || 'Palette vorbestellen'))
        : fmt(t.palletMissing || 'Noch {{ count }} Kartons bis zur Palette', { count: missing.toLocaleString(locale) });
      return { sum, missing, full, n };
    };
    pallet.addEventListener('input', (event) => {
      clamp(event.target);
      if (event.target === countEl && countEl.value !== '' && Number(countEl.value) !== count()) countEl.value = count();
      update();
    });
    pallet.querySelector('[data-pallet-fill]')?.addEventListener('click', () => {
      // Rest gleichmäßig auf alle Sorten verteilen, Überhang auf die ersten.
      let { missing } = update();
      const share = Math.floor(missing / inputs.length);
      inputs.forEach((i, n) => {
        const extra = n < missing - share * inputs.length ? 1 : 0;
        i.value = (parseInt(i.value, 10) || 0) + share + extra;
      });
      update();
    });
    pallet.addEventListener('submit', async (event) => {
      event.preventDefault();
      if (!update().full) {
        inputs[0].focus();
        return;
      }
      const items = inputs
        .map((i) => ({ id: Number(i.dataset.variantId), quantity: (parseInt(i.value, 10) || 0) * count(), properties: { _palette: pallet.dataset.group } }))
        .filter((item) => item.quantity > 0);
      submit.setAttribute('aria-busy', 'true');
      try {
        await addToCart(JSON.stringify({ items }), true);
        window.location.href = pallet.dataset.cartUrl;
      } catch (error) {
        status(out, error.message || t.palletError || 'Diese Palette können wir gerade nicht online vormerken. Rufen Sie uns an, wir reservieren sie für Sie.', true);
        submit.removeAttribute('aria-busy');
      }
    });
    update();
  }

  // Margenrechner (nur mit Login): Verkaufspreis brutto und MwSt. gibt der Kunde ein, Rohertrag rechnet sofort.
  if (calcEl) {
    const ek = Number(calcEl.dataset.ekCents);
    const week = Number(calcEl.dataset.week) || 0;
    const vkInput = calcEl.querySelector('[data-calc-vk]');
    const vatInput = calcEl.querySelector('[data-calc-vat]');
    const marginEl = calcEl.querySelector('[data-calc-margin]');
    const weekEl = calcEl.querySelector('[data-calc-week]');
    const taxEl = calcEl.querySelector('[data-calc-tax]');
    const num = (value) => parseFloat(String(value).replace(/\s/g, '').replace(/\.(?=\d{3})/g, '').replace(',', '.'));
    const run = () => {
      const vk = num(vkInput.value);
      const vat = Math.max(0, num(vatInput.value) || 0);
      if (!vk || vk <= 0 || !ek) {
        marginEl.textContent = '–';
        marginEl.classList.remove('is-negative');
        weekEl.hidden = true;
        taxEl.hidden = true;
        return;
      }
      const net = Math.round((vk * 100) / (1 + vat / 100));
      const margin = net - ek;
      // Aufschlag auf den Einkaufspreis (Rohertrag ÷ Einkauf), dazu die im Verkaufspreis enthaltene MwSt.
      const markup = (t.calcMarkup || '{{ value }} %').replace('{{ value }}', Math.round((margin / ek) * 100).toLocaleString(document.documentElement.lang || 'de'));
      marginEl.textContent = `${money(margin)} · ${markup}`;
      taxEl.textContent = (t.calcTax || '{{ value }}').replace('{{ value }}', money(Math.round(vk * 100) - net));
      taxEl.hidden = false;
      marginEl.classList.toggle('is-negative', margin < 0);
      weekEl.hidden = !week;
      if (week) {
        const value = document.createElement('b');
        value.textContent = (t.calcWeekValue || '{{ value }} Rohertrag').replace('{{ value }}', money(margin * week));
        weekEl.replaceChildren(`${(calcEl.dataset.weekLabel || t.calcWeek || 'Bei {{ count }} Stück pro Woche:').replace('{{ count }}', week)} `, value);
      }
    };
    [vkInput, vatInput].forEach((input) => input.addEventListener('input', run));
    run();
  }

  // Mitlaufende Leiste, sobald die Kaufbox nach oben aus dem Bild ist (mobil).
  const sticky = document.querySelector('[data-sticky-buy]');
  const anchor = document.querySelector('[data-buy-anchor]');
  if (sticky && anchor && 'IntersectionObserver' in window) {
    sticky.hidden = false;
    new IntersectionObserver(([entry]) => {
      const show = !entry.isIntersecting && entry.boundingClientRect.top < 0;
      sticky.classList.toggle('is-visible', show);
      sticky.inert = !show;
      document.body.classList.toggle('has-sticky-buy', show);
    }).observe(anchor);
  }

  // Nach „Benachrichtigen“: Bestätigung vorlesen.
  document.querySelector('[data-focus-on-load]')?.focus();
})();
